var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.superAdmin
      ? _c("div", { staticClass: "mb-15" }, [
          _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmMethods.confirm,
                  expression: "confirmMethods.confirm",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.confirmMethods.confirm)
                  ? _vm._i(_vm.confirmMethods.confirm, null) > -1
                  : _vm.confirmMethods.confirm,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.confirmMethods.confirm,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.confirmMethods,
                          "confirm",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.confirmMethods,
                          "confirm",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.confirmMethods, "confirm", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider bg-grey3 round" }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.superAdmin
      ? _c("div", { staticClass: "mb-15" }, [
          _c(
            "label",
            {
              staticClass: "switch withLabelFullWith mb-0",
              on: {
                click: function ($event) {
                  return _vm.warnManager()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
                },
                [_vm._v("\n\t\t\t\tConfirmation de la commande ?\n\t\t\t\t")]
              ),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "checkbox", disabled: "" },
                domProps: { checked: _vm.confirmMethods.confirm },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "slider bg-grey3 round" }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [
            _vm._v(
              "\n\t\t\t\tConfirmation de la commande (Mode à table) ?\n\t\t\t\t"
            ),
          ]
        ),
        _vm._v(" "),
        _vm.confirmMethods.confirm
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.shop.info.confirm.restaurant,
                  expression: "shop.info.confirm.restaurant",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.shop.info.confirm.restaurant)
                  ? _vm._i(_vm.shop.info.confirm.restaurant, null) > -1
                  : _vm.shop.info.confirm.restaurant,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.shop.info.confirm.restaurant,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "restaurant",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "restaurant",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.shop.info.confirm, "restaurant", $$c)
                  }
                },
              },
            })
          : _c("input", {
              attrs: { type: "checkbox", disabled: "" },
              domProps: { value: false },
            }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [
            _vm._v(
              "\n\t\t\t\tConfirmation de la commande Click & Collect (Modes Sur place + A emporter) ?\n\t\t\t\t"
            ),
          ]
        ),
        _vm._v(" "),
        _vm.confirmMethods.confirm
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.shop.info.confirm.clickCollect,
                  expression: "shop.info.confirm.clickCollect",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.shop.info.confirm.clickCollect)
                  ? _vm._i(_vm.shop.info.confirm.clickCollect, null) > -1
                  : _vm.shop.info.confirm.clickCollect,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.shop.info.confirm.clickCollect,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "clickCollect",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "clickCollect",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.shop.info.confirm, "clickCollect", $$c)
                  }
                },
              },
            })
          : _c("input", {
              attrs: { type: "checkbox", disabled: "" },
              domProps: { value: false },
            }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [
            _vm._v(
              "\n\t\t\t\tConfirmation de la commande (Mode livraison) ?\n\t\t\t\t"
            ),
          ]
        ),
        _vm._v(" "),
        _vm.confirmMethods.confirm
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.shop.info.confirm.delivery,
                  expression: "shop.info.confirm.delivery",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.shop.info.confirm.delivery)
                  ? _vm._i(_vm.shop.info.confirm.delivery, null) > -1
                  : _vm.shop.info.confirm.delivery,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.shop.info.confirm.delivery,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "delivery",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.shop.info.confirm,
                          "delivery",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.shop.info.confirm, "delivery", $$c)
                  }
                },
              },
            })
          : _c("input", {
              attrs: { type: "checkbox", disabled: "" },
              domProps: { value: false },
            }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _vm.superAdmin
      ? _c("div", { staticClass: "mb-15" }, [
          _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmMethods.payCard,
                  expression: "confirmMethods.payCard",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.confirmMethods.payCard)
                  ? _vm._i(_vm.confirmMethods.payCard, null) > -1
                  : _vm.confirmMethods.payCard,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.confirmMethods.payCard,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.confirmMethods,
                          "payCard",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.confirmMethods,
                          "payCard",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.confirmMethods, "payCard", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider bg-grey3 round" }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.superAdmin
      ? _c("div", { staticClass: "mb-15" }, [
          _c(
            "label",
            {
              staticClass: "switch withLabelFullWith mb-0",
              on: {
                click: function ($event) {
                  return _vm.warnManager()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
                },
                [_vm._v("\n\t\t\t\tPaiement carte de crédit ?\n\t\t\t")]
              ),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "checkbox", disabled: "" },
                domProps: { checked: _vm.confirmMethods.payCard },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "slider bg-grey3 round" }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [_vm._v("\n\t\t\t\tPaiement en points de fidélité ?\n\t\t\t")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.confirmMethods.payFidelite,
              expression: "confirmMethods.payFidelite",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.confirmMethods.payFidelite)
              ? _vm._i(_vm.confirmMethods.payFidelite, null) > -1
              : _vm.confirmMethods.payFidelite,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.confirmMethods.payFidelite,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payFidelite",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payFidelite",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.confirmMethods, "payFidelite", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [_vm._v("\n\t\t\t\tPaiement par Paygreen ?\n\t\t\t")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.confirmMethods.payPaygreen,
              expression: "confirmMethods.payPaygreen",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.confirmMethods.payPaygreen)
              ? _vm._i(_vm.confirmMethods.payPaygreen, null) > -1
              : _vm.confirmMethods.payPaygreen,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.confirmMethods.payPaygreen,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payPaygreen",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payPaygreen",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.confirmMethods, "payPaygreen", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-15" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [_vm._v("\n\t\t\t\tPaiement par Edenred ?\n\t\t\t")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.confirmMethods.payEdenred,
              expression: "confirmMethods.payEdenred",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.confirmMethods.payEdenred)
              ? _vm._i(_vm.confirmMethods.payEdenred, null) > -1
              : _vm.confirmMethods.payEdenred,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.confirmMethods.payEdenred,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payEdenred",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payEdenred",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.confirmMethods, "payEdenred", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-30" }, [
      _c("label", { staticClass: "switch withLabelFullWith mb-0" }, [
        _c(
          "span",
          {
            staticClass:
              "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
          },
          [_vm._v("\n\t\t\t\tPaiement par Como ?\n\t\t\t")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.confirmMethods.payComo,
              expression: "confirmMethods.payComo",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.confirmMethods.payComo)
              ? _vm._i(_vm.confirmMethods.payComo, null) > -1
              : _vm.confirmMethods.payComo,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.confirmMethods.payComo,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.confirmMethods, "payComo", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.confirmMethods,
                      "payComo",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.confirmMethods, "payComo", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "slider bg-grey3 round" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
      },
      [
        _vm._v("\n\t\t\t\tConfirmation de la commande ?\n\t\t\t\t"),
        _c(
          "span",
          {
            staticClass:
              "fsize-9 radius-4 border-bo-p1 color-bo-p1 px-5 text-uppercase mx-5",
          },
          [_vm._v("super admin")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "labelText flex-start-center pr-10 fsize-12 color-bo-grey1 text-regular",
      },
      [
        _vm._v("\n\t\t\t\tPaiement carte de crédit ?\n\t\t\t\t"),
        _c(
          "span",
          {
            staticClass:
              "fsize-9 radius-4 border-bo-p1 color-bo-p1 px-5 text-uppercase mx-5",
          },
          [_vm._v("super admin")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }